import { TypographyStyleOptions } from "@mui/material/styles/createTypography";
import * as colors from "./colors";

export const h1: TypographyStyleOptions = {
  fontSize: "2.6rem", // 42px
  fontWeight: "bold",
  letterSpacing: "-0.005em",
  fontStyle: "normal",
  fontFamily: "Nunito Sans, sans-serif",
};
export const h2: TypographyStyleOptions = {
  fontSize: "2.3rem", // 38px
  fontWeight: "bold",
  fontStyle: "normal",
  letterSpacing: "-0.005em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const h3: TypographyStyleOptions = {
  fontSize: "2rem", // 32px
  fontWeight: "bold",
  fontStyle: "normal",
  fontFamily: "Nunito Sans, sans-serif",
};
export const h4: TypographyStyleOptions = {
  fontSize: "1.75rem", // 28px
  fontWeight: "bold",
  fontStyle: "normal",
  letterSpacing: "0.0025em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const h5: TypographyStyleOptions = {
  fontSize: "1.5rem", // 24px
  fontWeight: "600",
  fontStyle: "normal",
  fontFamily: "Nunito Sans, sans-serif",
};
export const h6: TypographyStyleOptions = {
  fontSize: "1.25rem", // 20px
  fontWeight: "bold",
  fontStyle: "normal",
  fontFamily: "Nunito Sans, sans-serif",
};
export const subtitle1: TypographyStyleOptions = {
  fontSize: "1.1rem", // 18px
  fontWeight: "bold",
  fontStyle: "normal",
  letterSpacing: "0.0015em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const subtitle2: TypographyStyleOptions = {
  fontSize: "1rem", // 16px
  fontWeight: 600,
  fontStyle: "normal",
  letterSpacing: "0.001em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const subtitle3: TypographyStyleOptions = {
  fontSize: ".8rem", // 14px
  fontWeight: 700,
  fontStyle: "normal",
  letterSpacing: "0.001em",
  fontFamily: "Nunito Sans, sans-serif",
  lineHeight: 1.188,
};
export const body1: TypographyStyleOptions = {
  fontSize: ".8rem", // 14px
  fontWeight: 400,
  fontStyle: "normal",
  letterSpacing: "0.005em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const body2: TypographyStyleOptions = {
  fontSize: ".7rem", // 12px
  fontWeight: 600,
  fontStyle: "normal",
  letterSpacing: "0.0025em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const caption1: TypographyStyleOptions = {
  fontSize: ".7rem", // 12px
  fontWeight: 400,
  fontStyle: "normal",
  letterSpacing: "0.0125em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const caption2: TypographyStyleOptions = {
  fontSize: ".6rem", // 10px
  fontWeight: 400,
  fontStyle: "normal",
  letterSpacing: "0.004em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const caption3: TypographyStyleOptions = {
  fontSize: ".5rem", // 8px
  fontWeight: 300,
  fontStyle: "normal",
  letterSpacing: "0.004em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const button: TypographyStyleOptions = {
  fontSize: ".8rem", // 14px
  fontWeight: 600,
  fontStyle: "normal",
  letterSpacing: "0.0125em",
  fontFamily: "Nunito Sans, sans-serif",
};
export const code: TypographyStyleOptions = {
  fontSize: ".6rem", // 10px
  fontWeight: 600,
  fontStyle: "normal",
  letterSpacing: "0.0125em",
  fontFamily: "Nunito Sans, sans-serif",
  backgroundColor: colors.blue[50],
  padding: "1px 3px",
  borderRadius: 5,
};
export const overline: TypographyStyleOptions = {
  fontSize: ".4rem", // 6px
  fontWeight: 200,
  fontStyle: "normal",
  letterSpacing: "0.004em",
  fontFamily: "Nunito Sans, sans-serif",
};
